export type WorkAgentStep = {
  index: string;
  title: string;
  body: string;
};

export type WorkAgentCta = {
  id: string;
  label: string;
  href: string;
  logoSrc: string;
  logoAlt: string;
};

export const workAgentIntro = {
  kicker: "3Chat x 办公AI 私域客户运营",
  title: "让办公 AI 开始经营真实客户",
  body: [
    "不用导出名单，也不用给所有人发送同一句话。",
    "在豆包工作、千问办公或 WorkBuddy 中说出目标，3Chat 即可从真实客情中识别机会、生成一人一策；客户回复后，Agent 自动接棒。",
  ],
} as const;

export const workAgentDiagram = {
  src: "/images/workAgent/workAgent_cn.png",
  alt: "豆包工作、WorkBuddy、千问办公通过 3Chat 私域客户运营连接器接入微信私域",
} as const;

export const workAgentSteps: WorkAgentStep[] = [
  {
    index: "01",
    title: "说出目标，找到该跟的客户",
    body: "从真实客情中识别高意向、沉默或值得再次激活的客户。",
  },
  {
    index: "02",
    title: "读懂客情，生成一人一策",
    body: "结合购买阶段、兴趣偏好与未成交原因，生成针对性的触达内容。",
  },
  {
    index: "03",
    title: "确认触达，Agent 持续转化",
    body: "员工确认后执行触达；客户重新开口，由 Agent 接待并推进销售下一步。",
  },
];

export const workAgentCtas: WorkAgentCta[] = [
  {
    id: "doubao",
    label: "3Chat × 豆包工作",
    href: "/stories/doubao-work",
    logoSrc: "/images/workAgent/doubao_logo.png",
    logoAlt: "豆包工作",
  },
  {
    id: "workbuddy",
    label: "3Chat × WorkBuddy",
    href: "/stories/workbuddy",
    logoSrc: "/images/workAgent/workbuddy_logo.png",
    logoAlt: "WorkBuddy",
  },
];
